import React, { useRef } from 'react';
import styles from './Section6.module.scss';

interface DefinitionItem {
  type: string;
  definitions: string[];
  examples?: string[];
}

const Section6: React.FC = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const definitionRef = useRef<HTMLDivElement>(null);
  
  // 사전 정의 데이터
  const dictionaryData: DefinitionItem[] = [
    {
      type: "동사",
      definitions: [
        "어떤 것을 가능한 한 최소 크기나 정도로 줄이다.",
        "컴퓨터 화면에서 창을 아이콘으로 최소화하다."
      ]
    },
    {
      type: "형용사",
      definitions: [
        "최소한의 상태에 관한; 가능한 한 가장 적은.",
        "디자인, 예술 또는 생활 방식에서 미니멀리즘과 관련된."
      ]
    }
  ];

  // 모바일 화면에서 줄바꿈을 위한 함수
  const formatDefinition = (text: string, isMobile: boolean) => {
    if (!isMobile) return text;
    
    // 특정 문자열 이후에 줄바꿈 추가
    const breakPoints: Record<string, string> = {
      "어떤 것을 가능한 한 최소 크기나 정도로 줄이다.": "1. 어떤 것을 가능한 한<br />최소 크기나 정도로 줄이다.",
      "컴퓨터 화면에서 창을 아이콘으로 최소화하다.": "2. 컴퓨터 화면에서<br />창을 아이콘으로 최소화하다.",
      "최소한의 상태에 관한; 가능한 한 가장 적은.": "1. 최소한의 상태에 관한;<br />가능한 한 가장 적은.",
      "디자인, 예술 또는 생활 방식에서 미니멀리즘과 관련된.": "2. 디자인, 예술 또는<br />생활 방식에서 미니멀리즘과 관련된."
    };
    
    return breakPoints[text] || text;
  };

  // 화면 크기 체크 (모바일 환경 감지)
  const [isMobile, setIsMobile] = React.useState(false);
  
  React.useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 576);
    };
    
    // 초기 화면 크기 체크
    checkScreenSize();
    
    // 리사이즈 이벤트에 대응
    window.addEventListener('resize', checkScreenSize);
    
    // 컴포넌트 언마운트 시 이벤트 리스너 제거
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return (
    <section ref={sectionRef} className={styles.section6}>
      <div className={styles.container}>
        <div ref={definitionRef} className={styles.dictionaryCard}>
          <div className={styles.dictionaryHeader}>
            <h1 className={styles.word}>
              Minimize
            </h1>
            <div className={styles.phonetic}>
              <span className={styles.phoneticText}>
                /ˈmɪn.ə.maɪz/
              </span>
            </div>
          </div>

          <div className={styles.definitionsContainer}>
            {dictionaryData.map((item, itemIndex) => (
              <div key={`type-${itemIndex}`} className={styles.definitionBlock}>
                <div className={styles.wordType}>
                  {item.type}
                </div>
                
                <ol className={styles.definitionsList}>
                  {item.definitions.map((definition, defIndex) => (
                    <li 
                      key={`def-${itemIndex}-${defIndex}`}
                      className={styles.definitionItem}
                      dangerouslySetInnerHTML={{ 
                        __html: formatDefinition(definition, isMobile)
                      }}
                    />
                  ))}
                </ol>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Section6;